const fn = {}

// 网络监听
fn.alertOnlineStatus=(t)=>{
    navigator.onLine?t.$notify({
        title: '提示',
        message: '网络已连接',
        type: 'success'
    }):t.$notify({
        title: '提示',
        message: '网络链接异常,请检查网络',
        type: 'warning'
    });
    t.$store.commit('status/ONLINE', navigator.onLine)
}

// 日期选择器 选择日期大于今天的禁用
fn.dtAgreement=()=>{
    return {
        disabledDate(date) {  //选择日期大于今天的禁用
            const today = new Date();
            // 设置最大选择日期为今天
            return date>today;
        }
    }
}

// 日期选择器 初始化选择日期
fn.selectInit=(t)=>{
    let date = new Date(), date2 = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)),
    tdy = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    tdy2 = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()
    t.sprq[0] = tdy
    t.sprq[1] = tdy2
}


fn.rexMobile=(str)=>{
	return  /^1[3456789]\d{9}$/.test(str)
}


// 保留1位小数
fn.padDecimal=(str)=>{
    // 确保是数字类型，保留一位小数
    return parseFloat(str).toFixed(1);
}

// 保留2位小数
fn.padDecimal2=(str)=>{
    if (!isFinite(str)) return 0; // 处理 Infinity 或 -Infinity 的情况
    if (isNaN(str)) return 0;
    if (str == '') return 0;
    return parseFloat(str).toFixed(2);
}
// 保留3位小数
fn.padDecimal3=(str)=>{
    if (!isFinite(str)) return 0; // 处理 Infinity 或 -Infinity 的情况
    if (isNaN(str)) return 0;
    if (str == '') return 0;
    return parseFloat(str).toFixed(3);
}

// 保留4位小数
fn.padDecimal4=(str)=>{
    if (!isFinite(str)) return 0; // 处理 Infinity 或 -Infinity 的情况
    if (isNaN(str)) return 0;
    if (str == '') return 0;
    return parseFloat(str).toFixed(4);
}


// 返回选择城市的字符串
fn.getLabels=(value, t)=> {
    const labels = [];
    let options = t.shengShiQuData;

    for (let i = 0; i < value.length; i++) {
      const val = value[i];
      const option = options.find(item => item.value === val);

      if (option) {
        labels.push(option.label);
        options = option.children || []; // 更新 options 为子选项
      }
    }
    return labels;
}

//图片url网络链接转base64
fn.imageToBase64=(url)=>{
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // 解决跨域问题
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            const dataURL = canvas.toDataURL('image/png'); // 图片转Base64
            resolve(dataURL);
        };
        img.onerror = (error) => reject(error);
        img.src = url;
    })
}


//execl下载
fn.execlDownload = async (res, name, type, suffix) => {
    // let res = await t.$http.get(`${t.$api.daochubmjlexcel}?ssid=${ssid}&tiaojian1=${tiaojian1}&tiaojian2=${tiaojian2}&tiaojian3=${tiaojian3}`, {
    //     responseType: 'blob'
    // })//, time = new Date().getTime()
    let filesType = '', filesSuffix = ''

    if (type == 1) {
        filesType = 'application/msword‌'
    } else if (type == 2) {
        filesType = 'application/x-excel'
    } else if (type == 3) {
        filesType = 'application/mspowerpoint'
    }



    const excleData = new Blob([res], {type: filesType})
    if (typeof window.navigator.msSaveBlob != 'undefined'){
        window.navigator.msSaveBlob(excleData, name +'.'+ suffix)
    } else {
        const url = window.URL.createObjectURL(excleData)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name +'.'+ suffix)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url) //释放url
    }
}

//execl导入
fn.execlImport = async (row) => {
    let { data } = await this.$http.post(`${this.$api.daoruexcel}?tiaoshu=${row.id}`, this.formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    this.dialogVisible = false
    this.$notify({
        title: '提示',
    })
}

// 判断文件格式
fn.handleDocType = (fileType) => {
    let docType = 0;
    let fileTypesDoc = [
        'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'epub', 'fodt', 'htm', 'html', 'mht', 'odt', 'ott', 'pdf', 'rtf', 'txt', 'djvu', 'xps'
    ];
    let fileTypesCsv = [
        'csv', 'fods', 'ods', 'ots', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx'
    ];
    let fileTypesPPt = [
        'fodp', 'odp', 'otp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx'
    ];

    if (fileTypesDoc.includes(fileType)) {
        docType = 1
    }

    if (fileTypesCsv.includes(fileType)) {
        docType = 2
    }

    if (fileTypesPPt.includes(fileType)) {
        docType = 3
    }

    return docType;
}


export default fn